import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, useScroll, useTransform } from 'framer-motion';
import { primaryNavigation } from '../../seo/seoUtils';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const { scrollYProgress } = useScroll();
  const progressWidth = useTransform(scrollYProgress, [0, 1], ['0%', '100%']);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const isActiveLink = (path) => (
    path === '/' ? location.pathname === path : location.pathname.startsWith(path)
  );

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`} aria-label="Primary">
      <motion.div
        className="navbar__progress"
        style={{ width: progressWidth }}
        aria-hidden="true"
      />

      <div className="navbar__container">
        <Link
          to="/"
          className="navbar__brand"
          onClick={() => setIsOpen(false)}
          aria-label="Antaral Aerospace home"
          title="Antaral Aerospace home"
        >
          <span className="navbar__brand-mark" aria-hidden="true">
            <span className="navbar__brand-core"></span>
          </span>
          <span className="navbar__brand-copy">
            <span className="navbar__brand-title">Antaral</span>
            <span className="navbar__brand-subtitle">Aerospace Systems</span>
          </span>
        </Link>

        <div className={`navbar__panel ${isOpen ? 'is-open' : ''}`}>
          <ul className="navbar__links">
            {primaryNavigation.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className={isActiveLink(link.path) ? 'is-active' : ''}
                  onClick={() => setIsOpen(false)}
                  aria-current={isActiveLink(link.path) ? 'page' : undefined}
                  aria-label={link.schemaName}
                  title={link.schemaName}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>

          <Link
            to="/start-mission"
            className="navbar__cta btn btn-primary"
            onClick={() => setIsOpen(false)}
            aria-label="Book a rideshare with Antaral Aerospace"
            title="Book a rideshare with Antaral Aerospace"
          >
            Book a rideshare
          </Link>
        </div>

        <button
          type="button"
          className={`navbar__toggle ${isOpen ? 'is-open' : ''}`}
          onClick={() => setIsOpen((open) => !open)}
          aria-label="Toggle navigation menu"
          aria-expanded={isOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      <button
        type="button"
        className={`navbar__backdrop ${isOpen ? 'is-open' : ''}`}
        onClick={() => setIsOpen(false)}
        aria-label="Close navigation menu"
      ></button>
    </nav>
  );
};

export default Navbar;
